import { AdminSettings } from '@/features/app/types/admin-settings';
import { OrderItem } from '@/features/orders/types/order-item';
import { RawOrder } from '@/features/orders/types/raw-order-response';
import processTireDotField from '@/features/products/functions/processTireDotField';
import transformTireSize from '@/features/products/functions/transformTireSize';
import { match, P } from 'ts-pattern';

function transformOrderItem(
  item: RawOrder['orderItem'][number],
  {
    enableTireDot,
  }: {
    enableTireDot: boolean;
  }
): OrderItem {
  const type = match<typeof item, 'tireSize' | 'productBundle'>(item)
    .with({ tireSize: P.nonNullable.and(P.not(P.array())) }, () => 'tireSize')
    .with({ productBundle: P.nonNullable.and(P.not(P.array())) }, () => 'productBundle')
    .otherwise(() => 'productBundle');

  return match(type)
    .with('tireSize', () => {
      return {
        ...item,
        type: 'tireSize',
        tireSize: transformTireSize(item.tireSize!, enableTireDot),
        tireDot: processTireDotField(item.tireSize!, item.tireDot!, 'tireDot', enableTireDot),
        yearOfManufacture: item.yearOfManufacture,
      } as OrderItem;
    })
    .with('productBundle', () => {
      return {
        ...item,
        type: 'productBundle',
        productBundle: item.productBundle!,
      } as OrderItem;
    })
    .exhaustive();
}

export default transformOrderItem;
